export default __webpack_public_path__ + "static/media/benefits_simpleinv.b8517b78.svg";